<template>
  <v-card>
    <v-card-title>گزارش کدینگ حساب ها</v-card-title>

    <v-card-text>
      <m-datatable :headers="headers" :items="items" :filters.sync="filters">
        <template #item.created_at="{ item }">
          {{ item.created_at && getDateTime(item.created_at).date }}
        </template>
      </m-datatable>
    </v-card-text>
  </v-card>
</template>
<script>
import AccountApiMixin from "@/mixin/accountMixin";

export default {
  mixins: [AccountApiMixin],
  data() {
    return {
      filters: {},
      headers: [
        {
          text: "کد حساب",
          value: "code",
        },
        {
          text: "نام حساب",
          value: "name",
        },
        {
          text: "نوع",
          value: "type.name",
        },
        {
          text: "زمان ساخت",
          value: "created_at",
        },
        {
          text: "ساخته شده توسط",
          value: "created_by.name",
        },
      ],
    };
  },
  computed: {
    permissionBasename() {
      return `account`;
    },
    items() {
      return this.getSortedAccounts(this.accounts);
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.getAccounts(true);
    },
  },
};
</script>
